import { COMPONENTS } from '../../../components/components.registry';
import { FallbackFiltersConfig } from '../../../models';

export const DEFAULT_FALLBACK_FILTERS_CONFIG: FallbackFiltersConfig = {
  components: {
    panel: 'section',
    fallbackFacet: {
      component: COMPONENTS.PURE.FallbackFacet,
      header: '',
      footer: ''
    },
    fallbackFilter: {
      component: COMPONENTS.PURE.FallbackFilter,
      filter: COMPONENTS.PURE.CheckBoxFilter,
      grid: COMPONENTS.PURE.DefaultGrid,
      result: COMPONENTS.SMART.ConfigurableResult,
      header: '',
      footer: ''
    }
  },
  maxFiltersToShow: 4,
  maxResultsToShow: 6,
  /*maxGridsToShow: 2,*/
  gridColumns: 6
};
